/** Possible states for a Store Order entity. */
export enum STORE_ORDER_STATES {
  INCOMPLETE = 'INCOMPLETE',
  COMPLETED = 'COMPLETED',
  ISSUED = 'ISSUED',
  CLOSED = 'CLOSED',
  PROCESSING = 'PROCESSING',
  CANCELLED = 'CANCELLED',
  PARTIALLY_DISPATCHED = 'PARTIALLY_DISPATCHED',
  DISPATCHED = 'DISPATCHED',
}

/** Possible order types for a Store Order entity. */
export enum STORE_ORDER_TYPES {
  SALE = 'SALE',
  TRANSFER = 'TRANSFER',
  RETURN = 'RETURN',
}
